export const kidsToys = [
  {
    id: "marimba-arrastre",
    name: "Marimba de arrastre",
    tags: ["1–3 años"],
    price: "$110.000",
    description:
      "Suena mientras el niño camina. Clásico de arrastre que combina música y primeros pasos.",
    url: "https://iokus.co/products/marimba-arrastre",
    image:
      "https://iokus.co/cdn/shop/files/jirafa-marimba-arrastre-madera-sonido.jpg?v=1761606784&width=1000",
    alt: "Marimba de arrastre de madera para niños de 1 a 3 años, hecha por Iokus",
  },
  {
    id: "perro-arrastre",
    name: "Perro salchicha de madera",
    tags: ["1–3 años"],
    price: "$90.000",
    description:
      "Juguete de arrastre con cuerpo articulado que se mueve al caminar.",
    url: "https://iokus.co/products/perro-de-arrastre-toby",
    image:
      "https://iokus.co/cdn/shop/files/perro-salchicha-madera-arrastre-2.jpg?v=1759954700&width=1000",
    alt: "Perro salchicha de arrastre en madera con cuerpo articulado, juguete Iokus",
  },
  {
    id: "tren-desarmable",
    name: "Tren de madera desarmable",
    tags: ["2–5 años"],
    price: "$150.000",
    description:
      "Se arma, se desarma y se vuelve a armar. Motricidad fina sin que el niño se dé cuenta.",
    url: "https://iokus.co/products/tren-animales-desarmable",
    image:
      "https://iokus.co/cdn/shop/files/tren-didactico-de-animales-desarmable-madera.jpg?v=1758917608&width=1000",
    alt: "Tren de madera desarmable con piezas de animales, juguete didáctico de Iokus",
  },
  {
    id: "camion-bloques",
    name: "Camión de bloques",
    tags: ["2–5 años"],
    price: "desde $110.000",
    description:
      "Camión en madera con bloques de colores para encajar y transportar.",
    url: "https://iokus.co/products/camion-bloques-pequeno",
    image:
      "https://iokus.co/cdn/shop/files/camionBloquesLogicosMedianoPastel2.jpg?v=1712869820&width=1000",
    alt: "Camión de madera con bloques de colores para encajar, juguete de Iokus",
  },
  {
    id: "tangram",
    name: "Tangram de 7 piezas en madera",
    tags: ["3–6 años"],
    price: "$30.000",
    description:
      "Siete piezas, infinitas figuras. El regalo pequeño que más rinde.",
    url: "https://iokus.co/products/tangram-multicolor-madera",
    image: "https://iokus.co/cdn/shop/files/Tangram_PNG.png?v=1719431060&width=1000",
    alt: "Tangram de 7 piezas en madera multicolor, rompecabezas de Iokus",
  },
  {
    id: "muneca-colombianita",
    name: "Muñeca colombianita",
    tags: ["3+ años"],
    price: "$40.000",
    description:
      "Muñeca de madera con vestido tradicional. Recuerdo de Colombia hecho a mano.",
    url: "https://iokus.co/products/muneca-colombianita",
    image:
      "https://iokus.co/cdn/shop/files/muneca-Colombianita-artesanal-estimulacion-sensorial-ninos2.jpg?v=1749161258&width=1000",
    alt: "Muñeca colombianita de madera con vestido tradicional, recuerdo hecho a mano por Iokus",
  },
];